module.exports = __webpack_public_path__ + "img/why2.c99bc456.png";